import {
  USER_NOTIFICATION_FETCH_STARTED,
  USER_NOTIFICATION_FETCH_SUCCEEDED,
  USER_NOTIFICATION_READ,
  USER_NOTIFICATION_DELETE,
  USER_NOTIFICATION_FETCH_FAILED,
  USER_NOTIFICATION_CLEAR,
  USER_NOTIFICATION_COUNT_FETCH_SUCCEEDED
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  notifications: [],
  totalCount: null,
  unread: null,
  error: null,
  offset: 0,
  limit: 20,
  hasMore: true
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USER_NOTIFICATION_FETCH_STARTED:
      return { ...state, status: statuses.loading };
    case USER_NOTIFICATION_FETCH_SUCCEEDED:
      const { notifications, unread, totalCount, hasMore } = action.payload;
      const combined = totalCount > 0 ? [...state.notifications, ...notifications] : [];

      const uniqueNotifications = combined.reduce((acc, notification) => {
        if (!acc.seen.has(notification.id)) {
          acc.seen.add(notification.id);
          acc.result.push(notification);
        }
        return acc;
      }, { seen: new Set(), result: [] }).result;

      uniqueNotifications.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

      return {
        ...state,
        unread,
        hasMore,
        totalCount,
        status: statuses.succeeded,
        notifications: uniqueNotifications,
        offset: action.payload.offset + state.limit
      };
    case USER_NOTIFICATION_COUNT_FETCH_SUCCEEDED:
      return {
        ...state,
        totalCount: action.payload.totalCount,
        unread: action.payload.unread
      };
    case USER_NOTIFICATION_READ:
      const { id, updatedCount, readAll, isRead } = action.payload;

      const updatedNotifications = readAll ?
        state.notifications.map(notification => ({ ...notification, isRead: 1 })) :
        state.notifications.map(notification => {
          if (id.includes(notification.id)) {
            return {
              ...notification,
              isRead
            };
          }
          return notification;
        });

      return {
        ...state,
        notifications: updatedNotifications,
        unread: state.unread + (isRead ? -updatedCount : updatedCount)
      };
    case USER_NOTIFICATION_DELETE:
      const { deleteAll, id: deletedIds } = action.payload;

      if (deleteAll) {
        return {
          ...state,
          offset: 0,
          notifications: []
        };
      }

      return {
        ...state,
        notifications: state.notifications.filter(n => !deletedIds.includes(n.id))
      };
    case USER_NOTIFICATION_FETCH_FAILED:
      return {
        ...state,
        status: statuses.failed,
        error: action.error
      };
    case USER_NOTIFICATION_CLEAR:
      return {
        ...state,
        status: statuses.idle,
        offset: 0,
        hasMore: true,
        notifications: []
      };
    default:
      return state;
  }
};
